import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { addZero } from 'helpers/math'
import './BirthdaySelect.scss'
import useLocalization from '../../../../../hooks/useLocalization'

// Дни
let aDay = Array.from({ length: 31 }, (v, i) => ++i)

const BirthdaySelect = ({ onChange, ...props }) => {
  const [birthday, setBirthday] = useState({
    day: new Date(props.value).getDate() || null,
    month: new Date(props.value).getMonth() + 1 || null,
    year: new Date(props.value).getFullYear() || null,
  })
  const [error, serError] = useState([])

  const { translate } = useLocalization({
    section: 'profile',
    subsection: 'profile_modal_month',
    dict: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
      day: 'Day',
      year: 'Year',
      month: 'Month',
    },
  })

  // Месяцы
  const aMonth = [
    { id: 1, name: translate?.january, days: 31 },
    { id: 2, name: translate?.february, days: 28 },
    { id: 3, name: translate?.march, days: 31 },
    { id: 4, name: translate?.april, days: 30 },
    { id: 5, name: translate?.may, days: 31 },
    { id: 6, name: translate?.june, days: 30 },
    { id: 7, name: translate?.july, days: 31 },
    { id: 8, name: translate?.august, days: 31 },
    { id: 9, name: translate?.september, days: 30 },
    { id: 10, name: translate?.october, days: 31 },
    { id: 11, name: translate?.november, days: 30 },
    { id: 12, name: translate?.december, days: 31 },
  ]
  // Годы
  const aYear =
    props.years === 'currentPlus3'
      ? Array.from({ length: 3 }, (v, i) => i + new Date().getFullYear())
      : Array.from({ length: 122 }, (v, i) => i + 1900).reverse()

  useEffect(() => {
    const { year, month, day } = birthday
    if (month !== null && day !== null) {
      const selectedMonth = aMonth.find((x) => x.id === month)
      let isLeap = selectedMonth.id === 2 && year % 4 === 0
      let daysInMonth = selectedMonth.days

      if (isLeap) {
        daysInMonth += 1
      }

      if (day > daysInMonth) {
        setBirthday({ ...birthday, day: daysInMonth })
        return
      }

      if (year !== null) {
        const returnValue = `${year}-${addZero(month)}-${addZero(day)}`
        if (returnValue !== props.value) onChange(returnValue)
      }

      let updatedDays = []
      for (let i = 1; i <= daysInMonth; i++) {
        updatedDays.push(i)
      }
      aDay = [...updatedDays]
    }
  }, [birthday, onChange, props.value])

  useEffect(() => {
    if (props.error) {
      const values = Object.keys(birthday).filter(
        (key) => birthday[key] === null,
      )
      serError(values)
    } else {
      serError([])
    }
  }, [props.error, birthday])

  return (
    <div className='birthdaySelect'>
      <div className='birthdaySelect__item'>
        <SelectCustom
          isDisabled={props.disabled}
          placeholder={translate?.day}
          options={aDay.map((day) => ({
            id: day,
            name: addZero(day),
          }))}
          onChange={(o) => setBirthday({ ...birthday, day: o.id })}
          valueID={birthday.day}
          error={error.includes('day')}
          className='birthdaySelect__selectCustom'
        />
      </div>
      <div className='birthdaySelect__item'>
        <SelectCustom
          isDisabled={props.disabled}
          placeholder={translate?.month}
          options={aMonth}
          onChange={(o) => setBirthday({ ...birthday, month: o.id })}
          valueID={birthday.month}
          error={error.includes('month')}
          className='birthdaySelect__selectCustom'
        />
      </div>
      <div className='birthdaySelect__item'>
        <SelectCustom
          isDisabled={props.disabled}
          placeholder={translate?.year}
          options={aYear.map((year) => ({ id: year, name: year }))}
          onChange={(o) => setBirthday({ ...birthday, year: o.id })}
          valueID={birthday.year}
          error={error.includes('year')}
          className='birthdaySelect__selectCustom'
        />
      </div>
    </div>
  )
}

BirthdaySelect.propTypes = {
  onChange: PropTypes.func,
}

export default BirthdaySelect
